
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Aubervilliers dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Aubervilliers certifiée Google Partner, accompagne les entreprises albertivillariennes pour doper leur visibilité en ligne et gagner de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Aubervilliers dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Aubervilliers certifiée Google Partner, accompagne les entreprises albertivillariennes pour doper leur visibilité en ligne et gagner de nouveaux clients.",
        },
      ],
    };
  },
};
